var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_logout",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.657,
    height: 41.076,
    viewBox: "0 0 35.657 41.076",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2592",
    "data-name": "Path 2592",
    d: "M37.237,39.7a1.726,1.726,0,0,0-1.8,1.634,2.219,2.219,0,0,1-2.309,2.1H9.275a2.219,2.219,0,0,1-2.309-2.1V10.993a2.219,2.219,0,0,1,2.309-2.1H33.132a2.219,2.219,0,0,1,2.309,2.1,1.8,1.8,0,0,0,3.591,0,5.654,5.654,0,0,0-5.9-5.368H9.275a5.654,5.654,0,0,0-5.9,5.368v30.34a5.654,5.654,0,0,0,5.9,5.368H33.132a5.654,5.654,0,0,0,5.9-5.368A1.726,1.726,0,0,0,37.237,39.7Z",
    transform: "translate(-3.375 -5.625)",
    fill: "#f95047"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2593",
    "data-name": "Path 2593",
    d: "M30.694,11.147a1.363,1.363,0,0,0-.893-.319,1.339,1.339,0,0,0-.893.319.984.984,0,0,0,0,1.541l5.881,5H11.669a1.189,1.189,0,0,0-1.263,1.089,1.189,1.189,0,0,0,1.263,1.089H34.816l-5.737,4.988a1,1,0,0,0,0,1.541l.009.008a1.424,1.424,0,0,0,.884.3,1.323,1.323,0,0,0,.893-.319l7.451-6.412a1.394,1.394,0,0,0,0-2.272Z",
    transform: "translate(-3.245 1.772)",
    fill: "#f95047"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.b49d3b8011bb4091f6262b2d756152a6.svg";
export { ForwardRef as ReactComponent };